import './configureGlobals';
import './FeatureFlags';
import './sidecar';

import './decorators/qDecorator';

import '../common/attributes/tbAutoSelect';
import '../common/attributes/tbButtonClick';
import '../common/attributes/tbButtonDown';
import '../common/attributes/tbFocus/FocusCtrl';
import '../common/attributes/tbFocus/tbFocus';
import '../common/components/checkboxes/tbCheckbox';
import '../common/components/checkboxes/tbCheckboxGroup';
import '../common/components/checkboxes/tbCheckboxLabel';
import '../common/components/checkboxes/tbCheckboxTristate';
import '../common/components/tbDatePicker/tbDatePicker';
import '../common/react/angularDirectives';
import '../common/react/components/dataGrid/AngularToReactDataGridBridge';
import '../common/react/components/InterpolatedString';
import '../common/utilities/TableauLog';

import './actions/UserSettingsActions';

import '../settings/components/AnalyticsExtensionsSettingsForSite';
import '../settings/controllers/ServerSettingsFormCtrl';
import '../settings/controllers/SiteSettingsForAnalyticsExtensionsCtrl';
import '../settings/controllers/SiteSettingsForBridgeFormCtrl';
import '../settings/controllers/SiteSettingsForServerAdminFormCtrl';
import '../settings/controllers/SiteSettingsForSiteAdminFormCtrl';
import '../settings/directives/tbAnalyticsExtensionsSettingsForm';
import '../settings/directives/tbServerSettingsForm';
import '../settings/directives/tbSettingsCoordinator';
import '../settings/directives/tbSiteSettingsForBridgeForm';
import '../settings/directives/tbSiteSettingsForExtensionsForm';
import '../settings/directives/tbSiteSettingsForServerAdminForm';
import '../settings/directives/tbSiteSettingsForServerAdminFormAdapter';
import '../settings/directives/tbSiteSettingsForSiteAdminForm';
import '../settings/directives/tbSiteSettingsForSiteAdminFormAdapter';
import '../settings/welcomeChannelCustomization/controllers/CustomizationSettingsCtrl';
import '../settings/welcomeChannelCustomization/directives/tbCustomizationSettingsForm';

import './controllers/AddSiteCtrl';
import './controllers/AddUsersToGroupDialogCtrl';
import './controllers/AdminSiteStatusCtrl';
import './controllers/AuthenticateConnectionCtrl';
import './controllers/ContentSubplaceCtrl';
import './controllers/CreateOrEditScheduleCtrl';
import './controllers/CreatePersonalAccessTokenDialogCtrl';
import './controllers/DatasourcePublishResultCtrl';
import './controllers/EditTimeZoneCtrl';
import './controllers/FilterPanelCtrl';
import './controllers/GroupMembershipDialogCtrl';
import './controllers/InitializationCtrl';
import './controllers/LicensesCtrl';
import './controllers/LoginCtrl';
import './controllers/LoginSitePickerCtrl';
import './controllers/RequestPasswordResetCtrl';
import '../revisionHistory/controllers/RevisionHistoryDialogCtrl';
import './controllers/ScheduleSpaceDetailsCtrl';
import './controllers/ScimSettingsCtrl';
import './controllers/ServerStatusCtrl';
import './controllers/ServerUserSettingsSubspaceCtrl';
import './controllers/SignedOutCtrl';
import './controllers/SigninErrorCtrl';
import './controllers/SiteAuthenticationSettingsCtrl';
import './controllers/SiteUserSettingsSubspaceCtrl';
import './controllers/TimeZoneSiteSettingCtrl';
import './controllers/WorkbookPublishResultCtrl';

import './directives/childEventDirectives';
import './directives/keyEventDirectives';
import './directives/pixelStyleDirectives';
import './directives/tbApp';
import './directives/tbAuthenticationProviderSelector';
import './directives/tbBytesInputConverter';
import './directives/tbChangePassword';
import './directives/tbDataGrid';
import './directives/tbDataGridBody';
import './directives/tbDataGridHeaders';
import './directives/tbDataSourceCertificationEditor';
import './directives/tbDatasourceExtractRefreshScheduler';
import './directives/tbDatasourceExtractRemoteRefreshSelfServiceScheduler';
import './directives/tbDataSourceNlpSettingEditor';
import './directives/tbDaysPicker';
import './directives/tbDisabled';
import './directives/tbDisableSelection';
import './directives/tbEditableTags';
import './directives/tbEditableTextarea';
import './directives/tbEditLanguageAndLocale';
import './directives/tbEditTimeZone';
import './directives/tbEmailInputValidator';
import './directives/tbEmbeddedPassword';
import './directives/tbEnterSpaceEscapeDownOutside';
import './directives/tbFileDrop';
import './directives/tbFilteringListBox';
import './directives/tbFormattingHints';
import './directives/tbHidden';
import './directives/tbHref';
import './directives/tbIfFeatureFlag';
import './directives/tbInitialization';
import './directives/tbIntegerInputValidator';
import './directives/tbLocalizeTranslate';
import './directives/tbLoginSitePicker';
import './directives/tbMatchingInputsValidator';
import './directives/tbMousedownOutside';
import './directives/tbMouseupOutside';
import './directives/tbOmnibox';
import './directives/tbPasswordReset';
import './directives/tbPopover';
import './directives/tbPopup';
import './directives/tbPopupMenu';
import './directives/tbPopupMenuButton';
import './directives/tbPopupMenuContent';
import './directives/tbPortInputValidator';
import './directives/tbPreventInput';
import './directives/tbRadioButton';
import './directives/tbRangeInputValidator';
import './directives/tbRequestPasswordReset';
import './directives/tbResetStartPage';
import './directives/tbSAMLAuthenticationProvider';
import './directives/tbScroll';
import './directives/tbSelect';
import './directives/tbSelected';
import './directives/tbSelectionMenu';
import './directives/tbSiteIdInputValidator.ts';
import './directives/tbSiteRolePermissionsTable';
import './directives/tbStackedElement';
import './directives/tbTab';
import './directives/tbTagsInput';
import './directives/tbTemplateList';
import './directives/tbTextBox';
import './directives/tbTextDropdown';
import './directives/tbTextile';
import './directives/tbTimePicker';
import './directives/tbTimeZoneSiteSetting';
import './directives/tbTranscludeFn';
import './directives/tbTypeaheadFormat';
import './directives/tbUpdateSiteLogoForm';
import './directives/tbUserLimitValidator';
import './directives/tbUserNameInputValidator';
import './directives/tbVisible';
import './directives/tbViz';
import './directives/tbWindowResize';
import './directives/tbWorkbookExtractRefreshScheduler';
import './directives/tbWorkerProcessStatus';

import './factories/AngularContextFactory';

import './filters/ActiveLiveQueryRemoteAgentsFilter';
import './filters/LocalizedCountFilter';
import './filters/LocalizedDateFilter';
import './filters/LocalizedPercentFilter';
import './filters/LocLinkifierFilter';
import './filters/PadFilter';
import './filters/RemoteRefreshScheduleTypeNameFilter';
import './filters/ScheduleActionNameFilter';
import './filters/ScheduleFrequencyDescriptionFilter';
import './filters/ScheduleTypeNameFilter';
import './filters/SiteRoleFilter';
import './filters/SizeFilter';
import './filters/ToServerHelpUrl';

import './L10n/L10n';
import './L10n/LocalizeToNgTranslateAdapter';

import './models/FlowPlace';
import './models/Set';

import '../backgroundJob/types/BackgroundJobs';
import './resources/Content';
import './resources/Databases';
import './resources/DataConnections';
import './resources/DataConnectionTypes';
import './resources/Dataroles';
import '../revisionHistoryDatasource/resources/DatasourceRevisions';
import './resources/Datasources';
import './resources/Favorites';
import './resources/FlowOutputStepRuns';
import '../revisionHistoryFlow/resources/FlowRevisions';
import './resources/Flows';
import './resources/Languages';
import './resources/Locales';
import './resources/OAuthCredentials';
import './resources/ProjectNames';
import './resources/PublishedConnections';
import './resources/Recents';
import './resources/RemoteRefreshAgents';
import './resources/RemoteRefreshSchedules';
import './resources/RunFlowTasks';
import './resources/Schedules';
import './resources/ServerSettings';
import './resources/SiteNameSansIds';
import './resources/SiteNameWithIds';
import './resources/Sites';
import './resources/SiteTimeZones';
import './resources/Tables';
import './resources/UserSettings';
import './resources/WorkbookAccelerations';
import '../revisionHistoryWorkbook/resources/WorkbookRevisions';
import './resources/Workbooks';

import '../app/spaces/SpacesSiteUrls';
import './services/ActionHelpers';
import './services/ActionPanelService';
import './services/AddOAuthCredentialAction';
import './services/AddUsersToGroupAction';
import './services/ChangeContentOwnerAction';
import './services/ChangeContentTagsAction';
import './services/ChangeDatasourceDescriptionAction';
import './services/ChangeDatasourceRefreshModeAction';
import './services/ChangeDatasourceRemoteAgentAction';
import './services/ChangeDatasourceRemoteAgentReservationAction';
import './services/ChangeDatasourceRemoteQueryAgentAction';
import './services/ChangeDatasourceRemoteRefreshPropertiesAction';
import './services/ChangeDatasourcesTagsAction';
import './services/ChangeExternalContentContactAction';
import './services/ChangeFlowDescriptionAction';
import './services/ChangeFlowsTagsAction';
import './services/ChangeProjectDescriptionAction';
import './services/ChangeRunFlowTasksPriorityAction';
import './services/ChangeScheduleAction';
import './services/ChangeTagsActionHelper';
import './services/ChangeViewTagsAction';
import './services/ChangeWorkbookDescriptionAction';
import './services/ChangeWorkbooksTagsAction';
import './services/CheckConnectionCredentialsAction';
import './services/ClearOrphanedManagedKeychainAction';
import '../settings/services/ClearSavedRevisionsAction';
import './services/ConfirmActionDialog';
import './services/ConnectionAuthService';
import './services/ContentActionNotification';
import './services/ContentActions';
import './services/ContentFilterService';
import './services/ContentUrl';
import './services/CreateExtractTasksAction';
import './services/CreateProjectAction';
import './services/CreateRemoteRefreshScheduleAction';
import './services/CreateScheduleAction';
import './services/CreateSiteAction';
import './services/DataAlertErrors';
import './services/DataCatalogApiRequestsService';
import './services/DataQualityService';
import './services/DataRoleErrors';
import './services/DataSourceErrors';
import './services/DeleteConnectedDeviceAction';
import './services/DeleteContentsAction';
import './services/DeleteFlowAction';
import './services/DeleteMyCredentialsAction';
import './services/DeleteOAuthCredentialsAction';
import './services/DeletePersonalAccessTokenAction';
import './services/DeleteRemoteAgentAction';
import './services/DeleteRemoteRefreshSchedulesAction';
import '../revisionHistory/services/DeleteRevisionAction';
import './services/DeleteRunFlowTasksAction';
import './services/DeleteSchedulesAction';
import './services/DeleteSitesAction';
import './services/DesktopApplicationLaunchService';
import './services/EditConnectionAction';
import './services/EditGroupMembershipAction';
import './services/EditRemoteRefreshExpectedDurationAction';
import './services/EditRemoteRefreshScheduleAction';
import './services/EditSiteAction';
import '../userManagement/services/EditSiteMembershipAction';
import './services/ErrorMessageHandler';
import './services/ErrorNotifyingServer';
import './services/ExternalAuthService';
import './services/FavoriteService';
import './services/FetcherFactory';
import './services/FilterPanelService';
import './services/FlowErrors';
import './services/FlowsActionNotification';
import './services/ForcePasswordUpdateAction';
import './services/HideViewsAction';
import './services/LicensesService';
import './services/LocalAuthenticationConfigurationService';
import './services/LogoService';
import './services/MastheadNotifications';
import './services/MissingTranslationService';
import './services/ModalService';
import './services/MoveContentAction';
import './services/MoveToProjectAction';
import './services/NotifyingFutureActionService';
import './services/OAuthCredentialsService';
import './services/PasswordPolicyService';
import './services/PersonalAccessTokensService';
import './services/PollService';
import './services/PostLoginNotifications';
import '../revisionHistoryWorkbook/services/PreviewWorkbookRevisionAction';
import './services/ProjectErrors';
import './services/PublishDatasourceAction';
import './services/PublishFlowAction';
import './services/PublishWorkbookAction';
import '../revisionHistory/services/QueryService';
import './services/RenameAction';
import './services/ResetLoginRateLimitingAction';
import './services/RestApiService';
import './services/ResumeRunFlowTasksAction';
import '../revisionHistory/services/RevisionActions';
import '../revisionHistory/services/RevisionHistoryAction';
import './services/RunFlowAction';
import './services/RunFlowOnOutputStepsAction';
import './services/RunFlowOnOutputStepsNotification';
import './services/RunFlowTasksAction';
import './services/RunSchedulesAction';
import './services/RunServerSchedulesAction';
import './services/ScheduleErrors';
import './services/SchedulePermissions';
import './services/SearchSuggestionsService';
import './services/ServerService';
import './services/SessionService';
import './services/SetDisplayTabsAction';
import './services/SetScheduleStatusAction';
import './services/SiteAuthenticationSettingsService';
import './services/SiteSwitchService';
import './services/SiteUrlMatcherFactory';
import './services/SliceableFactory';
import './services/StartPageService';
import './services/TemplatePreloadService';
import './services/ToasterService';
import './services/UpdateLocalGroupGrantLicenseModeAction';
import './services/UpdateUserAuthenticationAction';
import './services/UrlTelemetryService';
import './services/UserLockoutMessageService';
import './services/UserSettingsCtrlCommon';
import './services/UserSettingsNotification';
import './services/ViewErrors';
import './services/VizService';
import './services/WindowPopupService';
import '../dataAcceleration/actions/WorkbookAccelerationActions';
import './services/WorkbookErrors';
import '../zeus/SiteExpirationNotification';

import 'focus-visible/dist/focus-visible.min.js';
import 'url-search-params-polyfill';

import './config';
import './ImagePreloader';

import './run';